import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailView のスタイル
 */
export const hotlineProDetailViewStyle = tv({
    slots: {
        button: ['mt-32', 'mx-auto'],
        content: ['py-24 px-16 md:p-32', 'mb-8', 'bg-white', 'shadow-md'],
        title: [headStyle({ color: 'base', isBold: true, size: 'xs' }), 'mb-24'],
    },
    variants: {
        /** タブ表示があるか */
        showTab: {
            false: {
                content: ['md:rounded-md'],
            },
            true: {
                content: ['md:rounded-b-md', 'md:rounded-tr-md'],
            },
        },
    },
});
